const {
  REACT_APP_API,
  REACT_APP_APPOINTMENT_URL = "https://appointments-api.philip-134.workers.dev",
} = process.env;

// Helper function to process state
const processState = (state) => {
  if (!state) return "unknown";

  // If state starts with 'in_store_', remove that part and uppercase the rest
  if (state.startsWith("in_store_")) {
    return state.replace("in_store_", "").toUpperCase();
  }

  return state;
};

export const getAppointments = async (state) => {
  const response = await fetch(`${REACT_APP_APPOINTMENT_URL}/appointments`, {
    headers: {
      "Content-Type": "application/json",
      state: processState(state),
    },
  });

  if (!response.ok) {
    throw new Error(`Acuity API error: ${response.statusText}`);
  }

  return response.json();
};

export const getMyAppointments = async (email) => {
  const response = await fetch(
    `${REACT_APP_APPOINTMENT_URL}/appointments/email/${email}`,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  if (!response.ok) {
    throw new Error(`Acuity API error: ${response.statusText}`);
  }

  return response.json();
};

export const getAppointment = async (id) => {
  const response = await fetch(
    `${REACT_APP_APPOINTMENT_URL}/appointments/${id}`,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  if (!response.ok) {
    throw new Error(`Acuity API error: ${response.statusText}`);
  }

  return response.json();
};

export const getAppointmentBySysId = async (sys_id) => {
  const response = await fetch(
    `${REACT_APP_APPOINTMENT_URL}/appointments/sys_id/${sys_id}`,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  if (!response.ok) {
    throw new Error(`Acuity API error: ${response.statusText}`);
  }

  return response.json();
};

export const getUnavailableTimes = async (date, state) => {
  const response = await fetch(
    `${REACT_APP_APPOINTMENT_URL}/availability/${date}`,
    {
      headers: {
        "Content-Type": "application/json",
        state: processState(state),
      },
    }
  );

  if (!response.ok) {
    throw new Error(`Acuity API error: ${response.statusText}`);
  }

  return response.json();
};

export const bookAppointment = async (appointment, state) => {
  const response = await fetch(`${REACT_APP_APPOINTMENT_URL}/appointments`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      state: processState(state),
    },
    body: JSON.stringify(appointment),
  });
  if (!response.ok) {
    throw new Error(`Acuity API error: ${response.statusText}`);
  }

  return response.json();
};

export const confirmAppointment = async (id, sys_id) => {
  try {
    const response = await fetch(
      `${REACT_APP_APPOINTMENT_URL}/appointments/${id}/${sys_id}`,
      {
        method: "POST",
      }
    );
    if (!response.ok) {
      throw new Error(`Acuity API error: ${response.statusText}`);
    }

    return response.json();
  } catch (error) {
    console.error("Failed to confirm appointment:", error);
    // Re-throw to ensure caller knows about the error
    throw error;
  }
};

export const checkAppointmentStillValid = async (id) => {
  return true;
};

const updateAppointmentTakeback = async (id, updateName, accessToken) => {
  if (!updateName || !accessToken) {
    return;
  }

  await fetch(`${REACT_APP_API}/appointment/takeback/${id}`, {
    method: `POST`,
    headers: {
      "Content-Type": `application/json`,
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ updateName }),
  });
};

export const cancelAppointment = async (
  id,
  updateName,
  accessToken,
  takebackId
) => {
  const response = await fetch(
    `${REACT_APP_APPOINTMENT_URL}/appointments/${id}`,
    {
      method: "DELETE",
    }
  );
  if (!response.ok) {
    throw new Error(`Acuity API error: ${response.statusText}`);
  }

  await updateAppointmentTakeback(takebackId, updateName, accessToken);

  return response.json();
};

export const updateAppointment = async (
  id,
  data,
  updateName,
  accessToken,
  takebackId
) => {
  const response = await fetch(
    `${REACT_APP_APPOINTMENT_URL}/appointments/${id}`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }
  );

  await updateAppointmentTakeback(takebackId, updateName, accessToken);

  return response.json();
};
